<nav mat-tab-nav-bar *ngIf="isSideNavEnabled" [tabPanel]="tabPanel" class="bottom-nav fixed-bottom-tab-container
">
  @for (scope of appScopes; track $index) {
  <!-- @if (scope.title === 'Historical Data') {
  <a mat-tab-link [matMenuTriggerFor]="menu" [active]="activeRoute === scope.route">
    <div class="flex-column">
      <mat-icon>{{ scope.icon }}</mat-icon>
    </div>
  </a>

  <mat-menu #menu="matMenu" xPosition="after">
    <cva-historical-data-menu-items [isNavExpanded]="false"></cva-historical-data-menu-items>
  </mat-menu>
  } @else { -->

  <a mat-tab-link href="#" (click)="onSelectTab($event, scope)" [active]="activeRoute === '/'+ ROUTE_CONSTANTS.CONSULTATION ? scope.route === '/appointment' : 
    ( ((activeRoute?.includes('templates'))?scope.route === '/'+ROUTE_CONSTANTS.SOAP_CONFIGURATION :  activeRoute === scope.route )
    ||activeRoute === scope.route)">
    <div class="flex-column">
      <mat-icon>{{ scope.icon }}</mat-icon>
    </div>
  </a>
  <!-- } -->
  }
</nav>
<mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>